import type { GridRenderCellParams } from '@mui/x-data-grid-premium';

import { ViewTableUtils } from 'app/main/components/page-layouts';

export interface KpisGoalsValuesAggregationType {
	module: string;
	value: string;
}

function renderKpiTarget(cellParams: GridRenderCellParams) {
	const operator =
		cellParams.row.kpgl_clause === 'greater' ? '≥' : cellParams.row.kpgl_clause === 'smaller' ? '≤' : '=';

	return (
		<>
			{operator} {renderKpiValue(cellParams)}
		</>
	);
}

function renderKpiValue({ value, row }: GridRenderCellParams) {
	if (row.kpis_format === 'currency') return ViewTableUtils.renderCurrency({ value });
	if (row.kpis_format === 'hours') return ViewTableUtils.renderDuration({ hours: value });
	return value || '--';
}

export default {
	renderKpiTarget,
	renderKpiValue
};
